import { Children, isValidElement } from 'react';
const findChildRecursively = (children, callback) => {
    return Children.toArray(children).some(child => {
        if (isValidElement(child)) {
            if (callback(child)) {
                return true;
            }
            if (child.props.children) {
                return findChildRecursively(child.props.children, callback);
            }
        }
        return false;
    });
};
export { findChildRecursively };
//# sourceMappingURL=findChildRecursively.js.map